import { FormLabel, styled, Box } from '@mui/material';
import { rem, Bold } from '@core-web/typography';

export const StyledFormLabel = styled('label')(({ theme: { spacing, palette, typography } }) => ({
  paddingTop: spacing(1.25),
  paddingBottom: spacing(1.5),
  marginBottom: spacing(1),
  height: spacing(1.25),
  color: palette.text.primary,
  fontWeight: 600,
  fontSize: rem(14),
  ' .field_label': {
    display: 'inline-block',
  },
  ' .asterick': {
    color: palette.error.main,
  },
}));
